import { useMemo } from 'react';
import { useLanguageStore } from '../stores/Language/useLanguageStore';
import defaultMenuData from '../data/menuItems.json';

/**
 * Custom hook để lấy translations cho ngôn ngữ hiện tại
 * @returns {Object} currentTranslations - Bản dịch cho ngôn ngữ hiện tại
 */
const useTranslations = () => {
  // Subscribe to individual properties to avoid selector cache issues
  const currentLanguage = useLanguageStore((state) => state.currentLanguage);
  const translations = useLanguageStore((state) => state.translations);

  const currentTranslations = useMemo(() => {
    return translations[currentLanguage] || defaultMenuData.content;
  }, [currentLanguage, translations]);
  
  
  return currentTranslations;
};

export default useTranslations;
